export const roundUp = value => {
  const number = isNaN(value) ? 0 : Number(value);
  return Number(number.toFixed(2));
};
